<template>
  <div>
    <ErrorForm v-if="showError" :error-message="errorMessage" />
    <BusinessDetailsForm
      @validationSuccess="handleValidationSuccess"
      @validationFailure="handleError"
    />
  </div>
</template>

<script>
import { mapStateModuleGetters } from '@/utils/state-modules';
import stateModuleAware from '@/mixins/state-module-aware';
import BusinessDetailsForm from '@/pages/business/components/BusinessDetailsForm.vue';
import ErrorForm from '@/components/forms/ErrorForm.vue';

export default {
  components: {
    ErrorForm,
    BusinessDetailsForm,
  },
  mixins: [stateModuleAware],
  data() {
    return {
      showError: false,
      errorMessage: null,
    };
  },
  computed: {
    ...mapStateModuleGetters(['steps']),
    currentStep() {
      return this.steps[this.$route.name];
    },
  },
  methods: {
    handleValidationSuccess() {
      this.dispatchToStateModule('UPDATE_STEP', {
        step: this.currentRoute,
      });
      this.$router.push({ name: this.currentStep.nextRoute.name });
    },
    handleError(error) {
      this.errorMessage = error;
      this.showError = true;
    },
  },
};
</script>
